App.factory('Location', ['restmod', (restmod) => {
  return restmod.model('/locations').mix({
    smartCommands: { hasMany: 'SmartCommand', path: 'smart_commands' }
  })
}])
